var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-primary"},[_c('i',{staticClass:"fa fa-check-circle-o fa-lg icon-button",attrs:{"title":"Marcar como processada"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarProcessado()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }